import React, { Component } from "react";
import styles from "./Header.module.css";

import DashedBtn from "../../../components/Button/DashedBtn";
import MainHead from "./MainHead";
import Guide from "./Guide.jsx";
import HeaderBanner from "./HeaderBanner";
import { useGeneralStyle } from "../../../context/GeneralStyleContext.jsx";
import useIsMobile from "../../../utils/isMobile.jsx";

function Header() {
  const isMobile = useIsMobile();
  const { navExpand } = useGeneralStyle();
  return (
    <>
      <header
        className={` ${styles.HeaderSection} ${
          !isMobile && navExpand && styles.HeaderSectionReduction
        }`}>
        <MainHead />
        <Guide />
        <HeaderBanner />
      </header>
    </>
  );
}

export default Header;
